module.exports = __webpack_public_path__ + "static/media/coming soon review.a6efa9a2.png";